import mixpanel from "mixpanel-browser";
import { attributionProps } from "./attribution";

mixpanel.init(process.env.REACT_APP_MIXPANEL_TOKEN);

// Older visits were identified by IP; go back to the device ID, shared with fiberfed.com.
if (/^(\d{1,3}\.){3}\d{1,3}$|^[0-9a-f]*:[0-9a-f:]+$/i.test(mixpanel.get_distinct_id())) {
  mixpanel.reset();
}
mixpanel.register(attributionProps());

let env_check = process.env.NODE_ENV === "production";

let actions = {
  identify: (id) => {
    if (env_check) mixpanel.identify(id);
  },
  alias: (id) => {
    if (env_check) mixpanel.alias(id);
  },
  register: (props) => {
    if (env_check) mixpanel.register(props);
  },
  track: (name, props) => {
    if (env_check) mixpanel.track(name, props);
  },
  people: {
    set: (props) => {
      if (env_check) mixpanel.people.set(props);
    },
  },
};

export let Mixpanel = actions;
